module.exports = __webpack_public_path__ + "img/fjm-logo-blanc-long.6148eefc.svg";